<template>
  <div>
    <el-label>税率汇总报表</el-label>

    <bsp-table
      :data.sync="list"
      ref="accountTable"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getTaxRateSummaryList"
      :showPagination="listQuery.page"
      style="width: 100%"
    >
      <bsp-table-column
        field=""
        title="所得性质"
        filter-type="input"
        width="10%">
        <template slot-scope="scope">
          <span>{{ scope.row.taxType }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        title="课税数量（人数）"
        filter-type="input"
        width="10%">
        <template slot-scope="scope">
          <span>{{ scope.row.empNum }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        filter-type="input"
        title="计税金额"
        width="10%">
        <template slot-scope="scope">
          <span>{{ scope.row.needTaxSum }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field=""
        filter-type="input"
        title="税率（%）"
        width="10%">
        <template slot-scope="scope">
          <span>{{ scope.row.taxRate }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        filter-type="input"
        title="应税金额"
        width="10%">
        <template slot-scope="scope">
          <span>{{ scope.row.taxIncomeSum }}</span>
        </template>
      </bsp-table-column>
    </bsp-table>


  </div>

</template>

<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {getTaxRateSummaryList} from "@/api/report/report";
  import {mapGetters} from 'vuex';
  export default {
    name: "taxRateSummaryLists",
    components: { bspTableColumn, bspTable},
    created(){
      this._getTaxRateSummaryList();

    },
    mounted() {

    },
    computed: {
      ...mapGetters([
        'dicts',
        'pms'
      ]),
    },
    data(){
      return{
        list:[],
        listQuery:{
          limit: 20,
          page: 1,
          total: 0
        }
      }
    },
    methods:{

      _getTaxRateSummaryList(){
        getTaxRateSummaryList(this.listQuery).then(res => {
          console.log(res);
          this.listQuery.total = res.data.total
          this.list = res.data.records
        } ).catch((error) => {
          console.log("错误信息"+error)
        })
      },
    }

  }

</script>

<style scoped>

</style>
